import { memo } from 'react'
import './index.scss'

type ServiceColumn = {
  label: string
  onClick: () => void
}

const ServiceColumn = memo(({ label, onClick }: ServiceColumn) => {
  return (
    <div
      className="ServiceColumn"
      role="button"
      tabIndex={0}
      onClick={() => onClick()}
    >
      {label}
    </div>
  )
})

export default ServiceColumn
